import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

/* history mode IIS url rewrite for web.config, excluding api subfolder.
    <rewrite>
      <rules>
        <rule name="Handle History Mode and custom 404/500" stopProcessing="true">
          <match url="(.*)" />
          <conditions logicalGrouping="MatchAll">
            <add input="{REQUEST_FILENAME}" matchType="IsFile" negate="true" />
            <add input="{REQUEST_FILENAME}" matchType="IsDirectory" negate="true" />
            <add input="{REQUEST_URI}" url="^api/.*" negate="true" />
          </conditions>
          <action type="Rewrite" url="/" />
        </rule>
      </rules>
    </rewrite>
*/
const router = new Router({
    //mode: 'hash',
    mode: "history",
    //base: process.env.BASE_URL,
    routes: [
        {
            path: "/accisureform",
            name: "accisureform",
            component: () => import(/* webpackChunkName: "AccisureForm" */ "./views/AccisureForm.vue"),
        },
        {
            path: "/Login",
            name: "Login",
            component: () => import(/* webpackChunkName: "Login" */ "./views/Login.vue"),
            beforeEnter: (to, from, next) => {
                if (store.getters["authentication/isLoggedIn"]) next({ name: "Layout" });
                else next();
            },
        },
        {
            path: "/MyMembershipCard/:year/:month/:day/:guid",
            name: "MyMembershipCard",
            components: { default: () => import(/* webpackChunkName: "MyMembershipCard" */ "./views/MyMembershipCard.vue") },
            props: { default: (route) => ({ year: route.params.year, month: route.params.month, day: route.params.day, guid: route.params.guid }) },
        },
        {
            path: "/",
            name: "Layout",
            component: () => import(/* webpackChunkName: "SideNavigation" */ "./layouts/SideNavigation.vue"),
            redirect: "Dashboard",
            meta: { requiresAuth: true },
            children: [
                {
                    path: "Companies",
                    name: "Companies",
                    component: () => import(/* webpackChunkName: "Companies" */ "./views/Companies.vue"),
                },
                {
                    path: "Brokers",
                    name: "Brokers",
                    components: { default: () => import(/* webpackChunkName: "Brokers" */ "./views/Brokers.vue") },
                    props: {
                        default: (/*route*/) => ({
                            //someId: route.params.someId,
                            //
                        }),
                    },
                },
                {
                    path: "BrokerFirms",
                    name: "BrokerFirms",
                    components: { default: () => import(/* webpackChunkName: "BrokerFirms" */ "./views/BrokerFirms.vue") },
                    props: {
                        default: (/*route*/) => ({
                            //someId: route.params.someId,
                            //
                        }),
                    },
                },
                {
                    path: "Representatives",
                    name: "Representatives",
                    component: () => import(/* webpackChunkName: "Representatives" */ "./views/Representatives.vue"),
                },
                {
                    path: "RepresentativeProducts",
                    name: "RepresentativeProducts",
                    component: () => import(/* webpackChunkName: "RepresentativeProducts" */ "./views/RepresentativeProducts.vue"),
                },
                {
                    path: "SubscribeFormSubmissions",
                    name: "SubscribeFormSubmissions",
                    component: () => import(/* webpackChunkName: "SubscribeFormSubmissions" */ "./views/SubscribeFormSubmissions.vue"),
                },
                                {
                    path: "CustomerImportJob",
                    name: "CustomerImportJob",
                    component: () => import(/* webpackChunkName: "CustomerImportJob" */ "./views/CustomerImportJob.vue"),
                },
                {
                    path: "Subscriptions",
                    name: "Subscriptions",
                    component: () => import(/* webpackChunkName: "Subscriptions" */ "./views/Subscriptions.vue"),
                },
                {
                    path: "Customers",
                    name: "Customers",
                    components: { default: () => import(/* webpackChunkName: "Customers" */ "./views/Customers.vue") },
                    props: { default: (route) => ({
                        status: route.params.status,
                        companyId: route.params.companyId
                    }) },
                },
                {
                    path: "Dashboard",
                    name: "Dashboard",
                    component: () => import(/* webpackChunkName: "Dashboard" */ "./views/Dashboard.vue"),
                },
                {
                    path: "Reports",
                    name: "Reports",
                    component: () => import(/* webpackChunkName: "Reports" */ "./views/Reports.vue"),
                },
                {
                    path: "Identities",
                    name: "Identities",
                    component: () => import(/* webpackChunkName: "Identities" */ "./views/Identities.vue"),
                },
                {
                    path: "Users",
                    name: "Users",
                    component: () => import(/* webpackChunkName: "Users" */ "./views/Users.vue"),
                },
                {
                    path: "UnmatchedSmsReplyMessages",
                    name: "UnmatchedSmsReplyMessages",
                    component: () => import(/* webpackChunkName: "Identities" */ "./views/UnmatchedSmsReplyMessages.vue"),
                },
                {
                    path: "DeclinedSmsReplyMessages",
                    name: "DeclinedSmsReplyMessages",
                    component: () => import(/* webpackChunkName: "Identities" */ "./views/DeclinedSmsReplyMessages.vue"),
                },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    var lastRefresh = Date.parse(localStorage.getItem("last-refresh"));
    var todayDateString = new Date().toISOString().substring(0, 10);
    var logout = false;
    if (isNaN(lastRefresh)) {
        logout = true;
    } else {
        var lastRefreshDateString = new Date(lastRefresh).toISOString().substring(0, 10);
        if (todayDateString != lastRefreshDateString) {
            logout = true;
        }
    }

    if (logout == true) {
        localStorage.setItem("last-refresh", todayDateString);
        store.dispatch("authentication/logout");
        location.reload();
    }

    if (to.matched.some((m) => m.meta.requiresAuth) && !store.getters["authentication/isLoggedIn"]) {
        next({ name: "Login" });
    } else {
        next();
    }
});

export default router;
